var scope_0 = require('/home/circleci/spokestack.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3648c5031a467d4ada4696b048791b8d.js').default;
var scope_1 = require('/home/circleci/spokestack.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c64d1eebfb130487b46310658512ce3a.js').default;
var scope_2 = require('/home/circleci/spokestack.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    